import { lazy } from "react";

const Invoices = lazy(() => import("../pages/invoices/Invoices"));
const ShowInvoice = lazy(() => import("../pages/invoices/ShowInvoice"));
const NewInvoice = lazy(() => import("../pages/invoices/NewInvoice"));
const NewCustomerInvoice = lazy(
  () => import("../pages/invoices/NewCustomerInvoice")
);

export const invoicesRoutes = [
  {
    path: "/invoices",
    component: Invoices,
  },
  {
    path: "/invoices/:id",
    component: ShowInvoice,
  },
  {
    path: "/invoices/new",
    component: NewInvoice,
  },
  {
    path: "/invoices/new/:customer",
    component: NewCustomerInvoice,
  },
];
